import _ from 'lodash';

import CMSModel from '@/visa-application/models/CMSModel';
import AddedValueServiceCMSModel from '@/visa-application/models/AddedValueServiceCMSModel';
import CurrencyCMSModel from '@/visa-application/models/CurrencyCMSModel';
import CountryCMSModel from '@/visa-application/models/CountryCMSModel';

export default class CountryAvsCMSModel implements CMSModel {
  country: CountryCMSModel = new CountryCMSModel();
  avs: AddedValueServiceCMSModel = new AddedValueServiceCMSModel();
  weight: number;
  name = '';
  short_description = '';
  long_description = '';
  video_url = '';
  price: number;
  currency: CurrencyCMSModel = new CurrencyCMSModel();

  map(obj: any): void {
    this.country.map(_.get(obj, 'country', {}));
    this.avs.map(_.get(obj, 'avs', {}));
    this.weight = _.get(obj, 'weight', 0);
    this.name = _.get(obj, 'translation[0].name', '');
    this.short_description = _.get(obj, 'translation[0].short_description', '');
    this.long_description = _.get(obj, 'translation[0].long_description', '');
    this.video_url = _.get(obj, 'translation[0].video_url', '');
    this.price = _.get(obj, 'price', 0);
    this.currency.map(_.get(obj, 'currency', {}));
  }
}
